var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.weapons.length ? _c('div', [_c('v-divider', {
    staticClass: "mb-4"
  }), _c('p', {
    staticClass: "px-4 title primary--text"
  }, [_vm._v(_vm._s(_vm.$t('Weapons')))]), _vm._l(_vm.weapons, function (weapon) {
    return [_c('Weapon', {
      attrs: {
        "id": weapon.m_ID
      }
    })];
  })], 2) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }